import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-change-name',
  templateUrl: './change-name.component.html',
  styleUrls: ['./change-name.component.scss'],
})
export class ChangeNameComponent implements OnInit {
  user;
  changeForm: FormGroup;
  isError = false;
  isErrorText = 'form-is-not-valid';

  constructor(
    public modalController: ModalController,
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private eventEmitterService: EventEmitterService,
    private fb: FormBuilder
  ) {
    this.user = this.authenticationService.userValue;
  }

  ngOnInit() {
    this.isError = false;
    this.isErrorText = 'form-is-not-valid';
    this.initForm();
  }

  initForm() {
    this.changeForm = this.fb.group({
      name: new FormControl(this.user.user.name, Validators.required),
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async save() {
    this.isError = false;
    this.isErrorText = 'something-went-wrong';

    if (this.changeForm.get('name').invalid) {
      this.isError = true;
      this.isErrorText = 'there-are-empty-fields';
      return;
    }

    this.usersService.changeName(this.changeForm.value).subscribe(
      (res) => {
        this.eventEmitterService.userUpdated();
        this.isError = false;
        this.isErrorText = 'something-went-wrong';
        this.closeModal();
      },
      (error) => {
        this.isError = true;
        this.isErrorText = 'something-went-wrong';
      }
    );
  }
}
